import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateDelivery } from 'app/dtos/Deliveries/updateDelivery';
import { CompanyService } from 'app/services/models/company.service';
import { DeliveryMethodService } from 'app/services/models/delivery-method.service';
import { DeliveryService } from 'app/services/models/delivery.service';
import { PersonService } from 'app/services/models/person.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delivery-update-dialog',
  templateUrl: './delivery-update-dialog.component.html',
  styleUrls: ['./delivery-update-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryUpdateDialogComponent implements OnInit {
  @Input() data;
  companies: any[] = [];
  companyPersons: any[] = [];
  persons: any[] = [];
  transactionManagements: any[] = [];
  deliveryMethods: any[] = [];

  selectedCompanyId: number = null;

  deliveryForm: FormGroup;

  date = new Date();
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    public ngbModal: NgbActiveModal,
    private companyService: CompanyService,
    private personService: PersonService,
    private deliveryMethodService: DeliveryMethodService,
    private transactionService: TransactionService,
    private fb: FormBuilder,
    private deliveryService: DeliveryService,
    private toastrService:ToastrService
  ) { }

  async ngOnInit() {
    this.deliveryForm = this.fb.group({
      companyId: [null, Validators.required],
      companyPersonId: [null],
      transactionManagementId: [null],
      deliveryDate: [null],
      personId: [null],
      deliveryMethodId: [null, Validators.required],
      deliveryPerson: [null],
      description: [null]
    });
    console.log(this.data);
    await this.getAllCompany('');
    await this.getAllPerson(1);
    await this.getAllDeliveryMethod();
    await this.getByIdDelivery(this.data);
  }

  async getByIdDelivery(id) {
    const data = await this.deliveryService.getByIdDelivery(id);
    console.log(data);
    await this.getAllPerson(data.companyId);
    await this.getAllCompanyIdTransactionManagement(data.companyId);
    this.date = new Date(data.deliveryDate)
    this.deliveryForm.patchValue({
      companyId: data.companyId,
      companyPersonId: data.companyPersonId,
      transactionManagementId: data.transactionManagementId,
      deliveryDate: this.date,
      personId: data.personId,
      deliveryMethodId: data.deliveryMethodId,
      deliveryPerson: data.deliveryPerson,
      description: data.description
    });
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async getAllCompany(search) {
    const data = await this.companyService.getAllCompany(search, 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async onCompanySelect(company: any) {
    console.log("Seçilen Firma ID:", company?.id);
    this.selectedCompanyId = company.id;
    this.companyPersons = [];
    this.transactionManagements = [];
    this.deliveryForm.patchValue({
      companyPersonId: null,
      transactionManagementId: null,
    });
    await this.getAllPerson(this.selectedCompanyId);
    await this.getAllCompanyIdTransactionManagement(this.selectedCompanyId);
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return `Oluşturuldu`;
      case 2:
        return `İptal Edildi`;
      case 3:
        return `Onaylandı`;
      case 4:
        return `Reddedildi`;
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  async getAllPerson(id) {
    const data = await this.personService.getAllCompaniesPersons(0, 50, id);
    console.log(data);
    if (id == 1) {
      this.persons = data.persons;
    } else {
      this.companyPersons = data.persons;
    }
  }

  async getAllCompanyIdTransactionManagement(id) {
    const data = await this.transactionService.getAllTransactionCompany(0, 50, 8, id);
    console.log(data);
    this.transactionManagements = data.transactionManagements;
  }

  async getAllDeliveryMethod() {
    const data = await this.deliveryMethodService.getAllDeliveryMethod(0, 100);
    console.log(data);
    this.deliveryMethods = data.deliveryMethods;
  }

  async onUpdateDelivery() {
    if (this.deliveryForm.valid) {
      const updatedDeliveryData = this.deliveryForm.value;

      // Bu veriyi bir servise gönderme veya başka bir işlem yapma
      const formData: UpdateDelivery = {
        id: this.data, // delivery.id'yi burada ekliyoruz
        companyId: updatedDeliveryData.companyId,
        transactionManagementId: updatedDeliveryData.transactionManagementId,
        deliveryPerson: updatedDeliveryData.deliveryPerson,
        personId: updatedDeliveryData.personId,
        companyPersonId: updatedDeliveryData.companyPersonId,
        deliveryDate: updatedDeliveryData.deliveryDate[0],
        deliveryMethodId: updatedDeliveryData.deliveryMethodId,
        description: updatedDeliveryData.description
      };
      console.log(formData);

      const data = await this.deliveryService.updateDelivery(formData);
      if(data.status){
        this.closeModal();
        this.deliveryService.sendEvent(true);
        this.toastrService.success(data.message);
      }else{
        this.toastrService.error(data.message);
      }
      
    } else {
      // Form geçerli değilse hata mesajı gösterebilirsiniz
      console.log('Form geçerli değil!');
    }
  }
}
